import { ContentReportStatus, ReportContentType } from 'api/types/moderation';

/** Backend serializes enums as strings; coerce API values for comparisons. */
export function coerceContentReportStatus(
  value: ContentReportStatus | string | number | null | undefined
): ContentReportStatus | null {
  if (value === null || value === undefined) return null;
  if (typeof value === 'number') return value as ContentReportStatus;
  if (typeof value === 'string') {
    switch (value) {
      case 'Pending':
        return ContentReportStatus.Pending;
      case 'Resolved':
        return ContentReportStatus.Resolved;
      case 'Dismissed':
        return ContentReportStatus.Dismissed;
      default:
        return null;
    }
  }
  return value;
}

export function coerceReportContentType(
  value: ReportContentType | string | number | null | undefined
): ReportContentType | null {
  if (value === null || value === undefined) return null;
  if (typeof value === 'number') return value as ReportContentType;
  if (typeof value === 'string') {
    switch (value) {
      case 'Profile':
        return ReportContentType.Profile;
      case 'Listing':
        return ReportContentType.Listing;
      case 'Reel':
        return ReportContentType.Reel;
      default:
        return null;
    }
  }
  return value;
}

export function isPendingReportStatus(
  value: ContentReportStatus | string | number | null | undefined
): boolean {
  return coerceContentReportStatus(value) === ContentReportStatus.Pending;
}
